/* c8 ignore start */
import { useEffect, useState } from "react";
import { useDeviceCheck, useElementInScreen } from "hooks";

export const useHandleHLSVideo = (loadMedia, videoRef, sources) => {
  const { screenType } = useDeviceCheck();
  const { isInViewPort } = useElementInScreen(videoRef);

  const { source, sourceWeb, source2K, source4K } = sources;
  const checkIsIphone = () => {
    return window.navigator.platform === "iPhone";
  };
  const [videoType, setVideoType] = useState("video/mp4");
  const [isIphone, setIsIphone] = useState(false);
  const [currentVideo, setCurrentVideo] = useState("");
  const [hls, setHls] = useState(null);
  const [hlsReady, setHlsReady] = useState(false);
  useEffect(() => {
    if (checkIsIphone()) {
      setHlsReady(true);
    }

    setIsIphone(checkIsIphone());
    if (checkIsIphone()) {
      return;
    }
    loadHls();
    return () => {
      if (!isIphone && hls) hls.destroy();
    };
  }, []); //eslint-disable-line

  const loadHls = async () => {
    const Hls = window.Hls;

    if (!Hls) {
      //hls not ready yet
      await sleep(100);
      await loadHls();
    } else {
      const localHls = new Hls();
      setHls(localHls);
    }
  };
  const sleep = async (ms) => {
    return new Promise((resolve) => {
      setTimeout(resolve, ms);
    });
  };
  useEffect(() => {
    if (!loadMedia) return;

    const localSources = [];
    if (source) localSources.push(source);
    if (sourceWeb) localSources.push(sourceWeb);
    if (source2K) localSources.push(source2K);
    if (source4K) localSources.push(source4K);
    let newSource = "";
    switch (screenType) {
      case "mobile":
        newSource = source;
        break;
      case "web":
        if (sources.length > 2) {
          newSource = localSources[1];
        } else {
          newSource = localSources.pop();
        }
        break;
      case "2k":
        if (localSources.length > 3) {
          newSource = localSources[2];
        } else {
          newSource = localSources.pop();
        }
        break;
      case "4k":
        newSource = localSources[3] ? localSources[3] : localSources.pop();
        break;
      default:
        newSource = source;
    }

    if (newSource !== currentVideo) {
      setCurrentVideo(newSource);
    }
  }, [screenType, isIphone, loadMedia]); //eslint-disable-line

  useEffect(() => {
    loadVideo();
  }, [currentVideo, videoRef, loadMedia, screenType, hls, hlsReady]); //eslint-disable-line
  const loadVideo = async () => {
    if (!hls) {
      await sleep(100);
    }

    if (!loadMedia) return;

    if (!isHlsTrack(currentVideo)) {
      setHlsReady(true);
      return;
    }

    const Hls = window.Hls;
    if (!videoRef.current) {
      await sleep(100);

      await loadVideo();
      return;
    }

    if (currentVideo && isHlsTrack(currentVideo)) {
      if (Hls?.isSupported() && !checkIsIphone()) {
        if (!hls) return;
        hls.loadSource(currentVideo);
        hls.attachMedia(videoRef.current);
        setVideoType("video/m3u8");
        hls.on(Hls.Events.MANIFEST_LOADED, function () {
          setHlsReady(true);
          if (isInViewPort) videoRef.current.play();
        });
      }
    }
  };

  const isHlsTrack = (track) => {
    const route = track.split("/").pop();
    const file = route.split("?")[0];
    return file.endsWith(".m3u8");
  };
  const getVideoType = (source) => {
    if (isHlsTrack(source)) return "video/m3u8";
    return "video/mp4";
  };
  return {
    videoType,
    getVideoType,
    isIphone,
    currentVideo,
    isHlsTrack,
    hlsReady,
  };
};
/* c8 ignore stop */
